<template>
     <div class="md-layout">
      <v-tour name="myTour" :steps="steps"></v-tour>
      <div class="md-layout-item md-size-25">
      <md-card>
       <md-card-content>
          <div class="md-layout-item">
            <md-field>
              <label for="classification">Classification</label>
              <md-select v-model="classification" name="classification" id="classification" class="tour-class" >
                <md-option value="good" class="tour-class-good">(G) Good</md-option>
                <md-option value="bad">(B) Bad</md-option>
                <md-option value="clump">(C) Clump</md-option>
                <md-option value="skip">I don't know</md-option>
              </md-select>
            </md-field>
          </div>
          <div class="md-layout-item">
           <div class="md-layout">
             <div class="md-layout-item md-size-50"></div>
             <div class="md-layout-item md-size-50">
               <div class="checklabel">
                 <label class="tour-defect-na">N/A&nbsp;&nbsp;</label>
                 <label class="tour-defect-minor">Minor</label>
                 <label class="tour-defect-major">Major</label>
               </div>
             </div>
           </div>
          </div>
          <div class="md-layout-item">
           <md-list class="defect-list tour-defect">
             <tri-state ref="tri1" hotkey="1" v-on:change="autoClassify()" v-model="defect.new_bruise" label="Fresh Mechanical Bruise"></tri-state>
             <tri-state ref="tri2" hotkey="2" v-on:change="autoClassify()" v-model="defect.old_bruise" label="Old Mechanical Bruise" class="tour-keyboard"></tri-state>
             <tri-state ref="tri3" hotkey="3" v-on:change="autoClassify()" v-model="defect.green" label="Green"></tri-state>
             <tri-state ref="tri4" hotkey="4" v-on:change="autoClassify()" v-model="defect.misshapen" label="Misshapen"></tri-state>
             <tri-state ref="tri5" hotkey="5" v-on:change="autoClassify()" v-model="defect.growth_crack" label="Growth Crack"></tri-state>
             <tri-state ref="tri6" hotkey="6" v-on:change="autoClassify()" v-model="defect.rizochtania" label="Rizochtania"></tri-state>
             <tri-state ref="tri7" hotkey="7" v-on:change="autoClassify()" v-model="defect.discoloration" label="Discoloration"></tri-state>
             <tri-state ref="tri8" hotkey="8" v-on:change="autoClassify()" v-model="defect.rodent" label="Rodent"></tri-state>
             <tri-state ref="tri8" hotkey="9" v-on:change="autoClassify()" v-model="defect.frozen" label="Frozen"></tri-state>
             <tri-state ref="tri22" hotkey="p" v-on:change="autoClassify()" v-model="defect.skin_check" label="Skin Check"></tri-state>
             <tri-state ref="tri1" hotkey="m" v-on:change="autoClassify()" v-model="defect.muddy" label="Muddy"></tri-state>
             <md-list-item md-expand>
               <md-icon>brightness_7</md-icon>
               <span class="md-list-item-text tour-defect-uncommon" >Early Season Defects</span>
               <md-list slot="md-expand">
                 <tri-state ref="tri9" hotkey="9" v-on:change="autoClassify()" v-model="defect.immaturity" label="Immaturity/Skinning"></tri-state>
                 <tri-state ref="tri10" hotkey="0" v-on:change="autoClassify()" v-model="defect.pink_rot" label="Pink Rot"></tri-state>
                 <tri-state ref="tri11" hotkey="-" v-on:change="autoClassify()" v-model="defect.enlarged_lenticels" label="Enlarged Lenticels"></tri-state>
               </md-list>
             </md-list-item>
             <md-list-item md-expand>
               <md-icon>brightness_3</md-icon>
               <span class="md-list-item-text">Late Season Defects</span>
               <md-list slot="md-expand">
                 <tri-state ref="tri12" hotkey="+" v-on:change="autoClassify()" v-model="defect.pressure_bruise" label="Pressure Bruise"></tri-state>
                 <tri-state ref="tri13" hotkey="q" v-on:change="autoClassify()" v-model="defect.air_checks" label="Air Checks"></tri-state>
                 <tri-state ref="tri14" hotkey="w" v-on:change="autoClassify()" v-model="defect.ingrown_sprouts" label="Ingrown Sprouts"></tri-state>
               </md-list>
             </md-list-item>
             <md-list-item md-expand>
               <md-icon>search</md-icon>
               <span class="md-list-item-text">Uncommon Defects</span>
               <md-list slot="md-expand">
                 <tri-state ref="tri15" hotkey="e" v-on:change="autoClassify()" v-model="defect.fresh_shatter_bruise" label="Fresh Shatter Bruise"></tri-state>
                 <tri-state ref="tri16" hotkey="r" v-on:change="autoClassify()" v-model="defect.old_shatter_bruise" label="Old Shatter Bruise"></tri-state>
                 <tri-state ref="tri17" hotkey="t" v-on:change="autoClassify()" v-model="defect.jelly_ends" label="Jelly Ends"></tri-state>
                 <tri-state ref="tri18" hotkey="y" v-on:change="autoClassify()" v-model="defect.nematode" label="Nematode"></tri-state>
                 <tri-state ref="tri19" hotkey="u" v-on:change="autoClassify()" v-model="defect.silver_scurf" label="Silver Scurf"></tri-state>
                 <tri-state ref="tri20" hotkey="i" v-on:change="autoClassify()" v-model="defect.scab" label="Scab"></tri-state>
                 <tri-state ref="tri21" hotkey="o" v-on:change="autoClassify()" v-model="defect.rot" label="Rot"></tri-state>
               </md-list>
             </md-list-item>
           </md-list>
          </div>
       </md-card-content>
      </md-card>
      <md-card style="margin-top:20px;">
       <md-card-content class="tour-filters">
         <div class="md-layout md-gutter">
           <div class="md-layout-item md-size-100">
             <md-field>
               <label style="margin-left:10px;">Brightness - <md-input v-model="brightness" size=1></md-input>%</label>
               <vue-material-slider style="width:100%" :thumbLabel="true" :min="100" :max="300" v-model="brightness" ></vue-material-slider>
             </md-field>
           </div>
           <div class="md-layout-item md-size-100">
             <md-field>
               <label style="margin-left:10px;">Contrast - <md-input v-model="contrast" size=1></md-input>%</label>
               <vue-material-slider style="width:100%" :thumbLabel="true" :min="100" :max="200" v-model="contrast" ></vue-material-slider>
             </md-field>
           </div>
           <div class="md-layout-item md-size-100">
             <md-field>
               <label style="margin-left:10px;">Zoom - <md-input v-model="zoom" size=1></md-input>%</label>
               <vue-material-slider style="width:100%" :thumbLabel="true" :min="100" :max="400" v-model="zoom" ></vue-material-slider>
             </md-field>
           </div>
           <div class="md-layout-item md-size-100">
             <md-button v-on:click="resetFilters()">Reset Filters</md-button>
           </div>
         </div>
       </md-card-content>
      </md-card>
      </div>
      <div class="md-layout-item md-size-75" >
      <md-card class="imgcard" id="imgcard">
       <md-card-content>
          <img :src="url" v-bind:style="'filter:brightness('+brightness+'%) contrast('+contrast+'%);zoom:'+zoom+'%'">
       </md-card-content>
       <md-card-actions>
       </md-card-actions>
      </md-card>
      </div>
    </div>
</template>

<style>
label input  {
  display:inline !important;
  margin-left:1em !important;
  font-size:12px !important;
}
</style>

<script>

import VueMaterialSlider from 'vue-material-slider'
import TriState from '@/components/TriState'

export default {
  name: 'labelimage',
  data: () => ({
    shownavigation: false,
    showsidepanel: false,
    url: '',
    classification: '',
    defect: {},
    green: 2,
    brightness: 100,
    contrast: 100,
    zoom: 100,
    radio: 0,
    steps: [
      { target: '.tour-class', content: 'Give the potato a classification here. You can select one of the options in the dropdown', params: { placement: 'top', enableScrolling: false } },
      { target: '.tour-class', content: 'A bad classification is given for any potato with a major defect. You must specify the defects.', params: { placement: 'top' } },
      { target: '.tour-class', content: 'A clump is any image with more than one potato. If any of the potatoes have defects please specify them.', params: { placement: 'top' } },
      { target: '.tour-defect', content: 'Defects are listed here. The most common defects are visible by default.', params: { placement: 'right' } },
      { target: '.tour-defect-na', content: 'Selecting N/A means that this defect is not found on this potato', params: { placement: 'right' } },
      { target: '.tour-defect-minor', content: 'Selecting minor means that the defect is present but is not severe enough to reject the potato as bad', params: { placement: 'right', enableScrolling: false } },
      { target: '.tour-defect-major', content: 'Selecting major means that the defect present and is severe enough to reject the potato as bad', params: { placement: 'right', enableScrolling: false } },
      { target: '.tour-defect-uncommon', content: 'Less common defects are hidden by default, you can expand them by clicking on the down arrow', params: { placement: 'top' } },
      { target: '.tour-filters', content: 'Adjustments to the image such as brightness and zoom can be found here', params: { placement: 'right' } },
      { target: '.tour-keyboard', content: 'There are several keyboard shortcuts available. For example (2) means that pressing 2 on your keyboard will manipulate this control.', params: { placement: 'right' } }
    ]
  }),
  props: ['dataset', 'image'],
  methods: {
    trychange: function () {
      console.log('Changing')
    },
    resetDefects: function () {
      console.log(this.classification)
      this.classification = 'good'
      console.log(this.classification)
      for (var key in this.$refs) {
        if (this.$refs.hasOwnProperty(key)) {
          if (key.startsWith('tri')) {
            this.$refs[key].reset()
          }
        }
      }
      this.autoClassify()
    },
    percent: function (job) {
      var pval = 100 * job.completed / job.total
      return pval.toFixed(1)
    },
    fetchImage: function (dataset, filename) {
      var self = this
      self.$root.loading++
      this.$auth.loaded().then(function () {
        self.axios.post('/api/imageurl',
          {'dataset': dataset, 'filename': filename},
          {headers: { Authorization: `Bearer ${self.$auth.getAccessToken()}` }})
          .then(response => {
            self.url = response.data
            self.$root.loading--
          }).catch(e => {
            console.error(e)
            self.$root.loading--
          })
      })
    },
    recordLabel: function () {
      var self = this
      var label = {'class': this.classification, 'defect': this.defect}
      var img = {'label': JSON.stringify(label), 'dataset': this.dataset, 'image': this.image}
      return new Promise((resolve, reject) => {
        self.$auth.loaded().then(function () {
          self.axios.post(`/api/labelimage`, img,
            {headers: { Authorization: `Bearer ${self.$auth.getAccessToken()}` }})
            .then(response => {
              self.resetDefects()
              resolve(self.checkedout)
            }).catch(e => {
              console.error(e)
              reject(e)
            })
        })
      })
    },
    autoClassify: function () {
      var bad = false
      for (var key in this.defect) {
        if (this.defect.hasOwnProperty(key)) {
          if (this.defect[key] > 1) {
            bad = true
          }
        }
      }
      if (this.classification === 'clump') return
      if (bad) {
        this.classification = 'bad'
      } else {
        this.classification = 'good'
      }
    },
    toggleDefect: function (tag) {
      this.defect[tag]--
      if (this.defect[tag] > 2) this.defect[tag] = 0
      if (this.defect[tag] < 0) this.defect[tag] = 2
      this.autoClassify()
    },
    resetFilters: function () {
      this.zoom = 100
      this.brightness = 100
      this.contrast = 100
    },
    isLabeled: function () {
      if (this.classification === 'bad' && this.defect.length > 0) {
        return true
      }
      if (this.classification === '') {
        return false
      }
      return true
    },
    keypress: function (e) {
      if (e.key === 'g') {
        this.classification = 'good'
      } else if (e.key === 'c') {
        this.classification = 'clump'
      } else if (e.key === 'b') {
        this.classification = 'bad'
      }
      for (var key in this.$refs) {
        if (this.$refs.hasOwnProperty(key)) {
          var tri = this.$refs[key]
          if (key.startsWith('tri') && tri.hotkey === e.key) {
            this.$refs[key].toggle()
            this.autoClassify()
          }
        }
      }
    }
  },
  components: {
    'vue-material-slider': VueMaterialSlider,
    'tri-state': TriState
  },
  watch: {
    image: function (newImage, oldImage) {
      if (this.dataset === '' || newImage === '') return
      this.fetchImage(this.dataset, this.image)
    }
  },
  mounted () {
    var el = document.getElementById('imgcard')
    var initY = el.getBoundingClientRect().y
    window.onscroll = function () {
      var off = window.pageYOffset
      if (off > initY) {
        var newPos = off - initY
        document.getElementById('imgcard').style.top = newPos + 'px'
      } else {
        document.getElementById('imgcard').style.top = '0px'
      }
    }
    this.$root.loading = 0
    for (var key in this.$refs) {
      if (this.$refs.hasOwnProperty(key)) {
        if (key.startsWith('tri')) {
          // this.$refs[key].addEventListener('valuechange', this.autoClassify)
        }
      }
    }
    console.log(this.$tours)
    this.$tours['myTour'].start()
    if (this.dataset === '' || this.image === '') return
    this.fetchImage(this.dataset, this.image)
  },
  created () {
    window.addEventListener('keydown', this.keypress)
    this.classification = 'good'
  },
  destroyed () {
    window.removeEventListener('keydown', this.keypress)
  }

}
</script>

<style lang="scss" >
.checklabel {
  position:relative;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.defect-list .md-list-item-content {
  padding-left:0px;
}
.v-step {
  z-index: 9999;
}
</style>



// WEBPACK FOOTER //
// src/components/LabelImage.vue